import { filterOperators } from '../filterOperators';
export const advancedFilterOperators = Object.freeze([
	{
		label: '= is',
		value: filterOperators.Equal,
	},
	{
		label: '≠ is not',
		value: filterOperators.NotEqual,
	},
	{
		label: '> is greater',
		value: filterOperators.GreaterThan,
	},
	{
		label: '≥ is greater or equal',
		value: filterOperators.GreaterOrEqualThan,
	},
	{
		label: '< is less',
		value: filterOperators.LowerThan,
	},
	{
		label: '≤ is less or equal',
		value: filterOperators.LowerOrEqualTahn,
	},
	{
		label: 'contains',
		value: filterOperators.Contains,
	},
	{
		label: 'starts with',
		value: filterOperators.StartsWith,
	},
	{
		label: 'is blank',
		value: filterOperators.IsBlank,
	},
	{
		label: 'is not blank',
		value: filterOperators.IsNotBlank,
	},
]);
